import { DraggedSingleData } from "../../../../components/ui/DragToolsUI";
import { HudActions } from "../../../../components/ui/hud/HUDUI";
import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { DaarcBaseScenario } from "../../../DaarcBaseScenario";
import GeneralNeutralStateMain, { GeneralNeutralStateMainConfig, GeneralNeutralStatePart2Config } from "../GeneralNeutralStateMain";

export default class GeneralNeutralStatePart2 extends BaseScenarioPart<DaarcBaseScenario> {
	private get config(): GeneralNeutralStatePart2Config {
		return this.scenarioConfig.part2Config;
	}
	constructor(private main: GeneralNeutralStateMain, private _scenario: DaarcBaseScenario, private onDone: () => void, private id: string, private scenarioConfig: GeneralNeutralStateMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		const context = this;
		context._scenario.currentTaskMessage = 'Please arrange tools';
		context._scenario.uiWrapper.displayHUD({
			score: context._scenario.totalScore,
			maxScore: this._scenario.maxScore,
			onActionClicked: (actionType: HudActions) => {
				if(context.main.onHudActionClicked(actionType)) {
					return true;
				}
				context._scenario.displayMessage(context._scenario.currentTaskMessage);
				return false;
			}
		}, context._scenario.hudId);

		context.scenario.toolbagId = context._scenario.uiWrapper.displayToolbag({
			toolsToChooseFrom: context.config.toolsToChooseFrom,
			onShouldShowOverlay: () => {
				return true;
			},
			onToolClicked: (data: DraggedSingleData) => {
			},
			onToolsArranged: (text: string[]) => context.onToolsArranged(text)
		}, context._scenario.toolbagId);
	}

	private onToolsArranged(tools: string[]) {
		const context = this;
		context._scenario.addScore(context._scenario.arrangeEquipmentPoints);
		// context.scenario.debriefLog('Organized Equipment');
		if(context.config.onToolsOrganized){
			context.config.onToolsOrganized();
		}
		context._scenario.uiWrapper.displayGeneralAlertUI({
			title: 'Message',
			text: 'Would you like to brief the team',
			okButton: {
				title: 'Yes',
				onClicked: () => {
					context._scenario.addScore(context._scenario.arrangeEquipmentBriefTeamPoints);
					if(context.config.onTeamDebriefed) {
						context.config.onTeamDebriefed();
					}
					context._scenario.uiWrapper.displayNotificationUI({
						text: [`
								<p class='notification-text'>Procedure Order</p>
						`].concat(tools.map(t => {
								return `<p class='notification-text'>${t}</p>`
						})).join(''),
						onDismissed: () => {
						}
					})

					context.onDone();
				}
			},
			cancelbutton: {
				title: 'No',
				onClicked: () => {
					if(context.config.onTeamNotDebriefed) {
						context.config.onTeamNotDebriefed();
					}
					context.onDone();
				}
			}
		});
	}
}